<template>
    <div v-if="total > 1" class="destino-pager d-flex align-center">
        <v-btn
            icon
            small
            :disabled="disabled || page <= 0"
            :title="$t('routePlanning.multiDestination.pager.previous')"
            @click="$emit('update:page', page - 1)"
        >
            <v-icon small>mdi-chevron-left</v-icon>
        </v-btn>
        <div class="flex-grow-1 text-center px-2 text-truncate">
            <span class="caption font-weight-medium">
                {{ $t('routePlanning.multiDestination.pager.pager', { current: page + 1, total }) }}
            </span>
            <span v-if="label" class="caption grey--text"> — {{ label }}</span>
        </div>
        <v-btn
            icon
            small
            :disabled="disabled || page >= total - 1"
            :title="$t('routePlanning.multiDestination.pager.next')"
            @click="$emit('update:page', page + 1)"
        >
            <v-icon small>mdi-chevron-right</v-icon>
        </v-btn>
    </div>
</template>

<script>
/**
 * Paginador de destinos da roteirização multi-destino (mesmo modelo do paginador da aba de
 * parâmetros dos recursos operacionais): anterior / "Destino N de M — nome" / próximo.
 */
export default {
    name: 'RoteirizacaoDestinoPager',
    props: {
        /** Quantidade de destinos; o paginador só aparece com > 1. */
        total: { type: Number, default: 0 },
        /** Página atual, base 0. */
        page: { type: Number, default: 0 },
        /** Rótulo do destino da página atual. */
        label: { type: String, default: null },
        disabled: { type: Boolean, default: false },
    },
};
</script>

<style scoped>
.destino-pager {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    padding-bottom: 4px;
}
</style>
